import { Section84_1ShareClassResult } from './section-84_1-share-class.result';
import { IsBoolean, IsInt, IsNotEmpty, IsOptional, ValidateIf, ValidateNested } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../builders/error-message.builder';
import { array } from '@pristine-ts/data-mapping-common';

export class Section84_1Result {
  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isArticle84_1Applicable: boolean;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  fairMarketValueOnValuationDayOfTransferredShares: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  actualCostOnJanuary1972OfTransferredShares: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  receivedDividendChoice83OnTransferredShares: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  elementAOfAdjustedCostBase: number;

  // MoneyType
  @ValidateIf((object: Section84_1Result) => object.isArticle84_1Applicable === true)
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  modifiedAdjustedCostBase: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalFairMarketValueOfSharesIssued: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalIncreasePaidUpCapitalDueToShareIssuance: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  deemedDividendElementE?: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  reducedPaidUpCapitalParagraphInElementB?: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  reducedPaidUpCapitalElementB?: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  reducedPaidUpCapital?: number;

  @ValidateNested()
  @array(Section84_1ShareClassResult)
  resultShareClasses: Section84_1ShareClassResult[] = [];

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  deemedDividend: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  amountReceivedForShareRedemption?: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  capitalGain: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  taxableCapitalGain: number;

  // Not displayed

}
